import { Link } from 'react-router-dom';
import './ProductCTA.css';

interface ProductCTAProps {
  variant?: 'engineering' | 'sales' | 'general';
  title?: string;
  description?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
}

const ProductCTA = ({ 
  variant = 'general', 
  title,
  description,
  primaryButtonText,
  secondaryButtonText 
}: ProductCTAProps) => {
  
  const getDefaultContent = () => {
    switch (variant) {
      case 'engineering':
        return {
          title: 'Ready to Discuss Your Project?',
          description: 'Contact our engineering team to discuss your requirements. We\'ll work with you to design the perfect solution for your application.',
          primaryButtonText: 'Request Engineering Quote',
          secondaryButtonText: 'Contact Engineering'
        };
      case 'sales':
        return {
          title: 'Interested in Our Available Equipment?',
          description: 'Contact our sales team for detailed specifications, pricing, and availability. We can also help source specific equipment.',
          primaryButtonText: 'Request Equipment Quote',
          secondaryButtonText: 'Speak with Sales'
        };
      default:
        return {
          title: 'Ready to Get Started?',
          description: 'Contact us today to discuss your manufacturing needs. Our experienced team is ready to help you find the perfect solution.',
          primaryButtonText: 'Request Quote',
          secondaryButtonText: 'Contact Us'
        };
    }
  };

  const defaultContent = getDefaultContent();

  return (
    <section className="product-cta-section">
      <div className="product-cta-content">
        <h2>{title || defaultContent.title}</h2>
        <p>{description || defaultContent.description}</p>
        <div className="product-cta-buttons">
          <Link to="/quote" className="btn btn-primary">
            {primaryButtonText || defaultContent.primaryButtonText}
          </Link>
          <Link to="/contact" className="btn btn-secondary">
            {secondaryButtonText || defaultContent.secondaryButtonText}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductCTA;